// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"xo-z","imageAndVideoCount":"yo-z","imageAndVideoContainer":"zo-z","viewAllReviews":"Ao-z"};